var map = {
	"./apple-laurel-da-DK.svg": 87953,
	"./apple-laurel-de-DE.svg": 49476,
	"./apple-laurel-en-GB.svg": 42127,
	"./apple-laurel-en-US.svg": 3321,
	"./apple-laurel-es-ES.svg": 5817,
	"./apple-laurel-es-MX.svg": 15870,
	"./apple-laurel-fr-FR.svg": 57367,
	"./apple-laurel-it-IT.svg": 28400,
	"./apple-laurel-nb-NO.svg": 71348,
	"./apple-laurel-nl-NL.svg": 12442,
	"./apple-laurel-pl-PL.svg": 81826,
	"./apple-laurel-pt-BR.svg": 39120,
	"./apple-laurel-pt-PT.svg": 87496,
	"./apple-laurel-sv-SE.svg": 92148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46036;